import { namespace } from '../../runtime'
import en from './en'

/** Classic's own copy (#1119). Classic is the eager template, so its English ships with the entry, as it did inline. */
export const siteClassicMessages = namespace('site-classic', en, {
  fr: () => import('./fr'),
  es: () => import('./es'),
})
